
import {take} from 'rxjs/operators';
import { Component, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppState } from '../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
    selector: 'conversation',
    templateUrl: 'conversation.component.html',
    styleUrls: ['conversation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConversationComponent implements OnDestroy{

    public messageBody: any;
    public historic: Array<any> = [];
    historicSubscription: Subscription;

    constructor(
        private store: Store<AppState>
    ) {
        this.historicSubscription = this.store.select(s => s.chat.messages).pipe(take(1)).subscribe(data => {
            this.historic = data;
        })
    }

    @Input() set conversation(conversation: Array<any>) {
        if (conversation) this.identifyConversationTypeMessage(conversation);
    }

    /**
     * Recebe o objeto message bruto, identifica se o retorno foi
     * de texto ou de anexos
     * 
     * @param message: message
     */
    identifyConversationTypeMessage(message: any) {
        if ("attachments" in message && message.attachments.length > 0) {
            this.getAttachments(message.attachments);
        }
        else {
            this.getText(message.text);
        }
    }

    /**
     * Recebe um array de attachments, percorre todos e repassa o objeto
     * 
     * @param attachments: Array<any> recebe um array de attachments 
     */
    getAttachments(attachments: any) {
        attachments.map((att, indx) => {
            this.messageBody = att;
        });
    }

    /**
     * Recebe o texto, e cria um objeto do tipo, plain.text
     * 
     * @param text: String Conteudo de texto vindo do bot
     */
    getText(text: any) {
        this.messageBody = {
            content: text,
            contentType: 'application/plain.text'
        };
    }

    //não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    ngOnDestroy() { }

}